import { spinnerSlice } from "./Slice";

//Wrapp nullable message
export const showSpinner = (message = '') => {
  return spinnerSlice.actions.showSpinner(message);
}

export const { hideSpinner } = spinnerSlice.actions;